<template>
  <div class="my-container-dad uk-padding-remove ">
    <app-header />
    <div>
      <router-view />
    </div>
    <div class="footer">
      <app-footer />
    </div>
  </div>
</template>
<script>
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'
export default {
  components: {
    AppHeader,
    AppFooter
  }
}
</script>

<style>
  @import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
  @import "../node_modules/ag-grid-community/dist/styles/ag-theme-alpine.css";
  @import "../node_modules/vue3-loading-overlay/dist/vue3-loading-overlay.css";
.cursor-pointer {
  cursor: pointer;
}
*{
  font-family:'Roboto',sans-serif !important;
  box-sizing: border-box;
  font-size: 12px;
}

.title{
  font-size: 16px;
  font-weight: 600;
}

.my-container-dad{
  width: 90%;
  margin: 0px auto;
  min-width: 320px;
  overflow: hidden;

}
.helper{
  font-size: 12px;
}

p, span {
  font-size: 12px;
}
.btn-restart{
  background: #fff i !important;
  margin: 0px 10px;
  cursor: pointer;
}
 .uk-button {
  background-color: #002c3f;
  color: #fff;
  font-size: 12px;
  padding-left: 8px;
  padding-right: 8px;
}
 .uk-button:disabled,
 .uk-button[disabled]{
  background-color: #adadadad;
  color: #fff;
}

@media screen and (max-width: 835px){
  .my-container-dad{
    width: 95%
  }
}
</style>
